import React from "react";
import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { CARGO_LABELS, formatEUR, formatDate } from "@/lib/constants";
import { Co2Badge } from "@/components/Co2Badge";
import { MapPin, ArrowRight, Calendar, Truck, BadgeCheck, Split } from "lucide-react";

export function RouteCard({ route }) {
  return (
    <Link to={`/tratta/${route.route_id}`} data-testid={`route-card-${route.route_id}`}
      className="group block border border-border rounded-sm bg-card p-5 transition-transform hover:-translate-y-1 hover:border-primary">
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <div className="flex items-center gap-2 font-display text-lg font-bold">
            <MapPin size={16} className="text-primary shrink-0" />
            <span className="truncate">{route.origin}</span>
            <ArrowRight size={16} className="text-accent shrink-0" />
            <span className="truncate">{route.destination}</span>
          </div>
          {route.stops?.length > 0 && (
            <p className="text-xs text-muted-foreground mt-1 font-mono-plex truncate">
              Tappe: {route.stops.join(" · ")}
            </p>
          )}
        </div>
        {route.partial_available && (
          <Badge className="bg-accent text-accent-foreground rounded-sm gap-1 shrink-0"><Split size={12} /> Parziale</Badge>
        )}
      </div>

      <div className="flex flex-wrap gap-1.5 mt-3">
        {route.cargo_types?.slice(0, 4).map((c) => (
          <span key={c} className="text-[11px] px-2 py-0.5 bg-muted rounded-sm border border-border">{CARGO_LABELS[c] || c}</span>
        ))}
        {route.cargo_types?.length > 4 && <span className="text-[11px] px-2 py-0.5 text-muted-foreground">+{route.cargo_types.length - 4}</span>}
      </div>

      <div className="flex items-center justify-between mt-4 pt-4 border-t border-border">
        <div className="flex items-center gap-3 text-xs text-muted-foreground">
          <span className="flex items-center gap-1"><Calendar size={13} /> {formatDate(route.departure_date)}</span>
          {route.vehicle_type && <span className="flex items-center gap-1"><Truck size={13} /> {route.vehicle_type}</span>}
        </div>
        <div className="text-right">
          <div className="font-display font-bold text-primary">{formatEUR(route.price_min)}{route.price_max > route.price_min ? ` – ${formatEUR(route.price_max)}` : ""}</div>
        </div>
      </div>

      <div className="mt-3 flex items-center justify-between gap-2">
        <div className="flex items-center gap-1 text-xs text-muted-foreground min-w-0">
          <span className="truncate">{route.carrier_name}</span>
          {route.carrier_verified && <BadgeCheck size={14} className="text-primary shrink-0" />}
        </div>
        <Co2Badge kg={route.co2_saved_kg} />
      </div>
    </Link>
  );
}
